import React from 'react';
import { useSelector } from 'react-redux';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import { useVerifyIsMobile } from '../../../../../../hooks/useVerifyIsMobile';
import useMenuRedirect from '../../../../../Menu/hooks/useMenuRedirect';
import { goToPlayerWithId } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { PUSHTOHISTORY } from 'constants';
import { getRegion } from 'utils/Region';
//---------------------------------------------------------------------------
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';
import { useNavigate } from 'react-router-dom';

export const PremiumChannelCard = ({
  contentInfo,
  carouselTitle,
  contentPosition,
}) => {
  const { main } = useSelector(state => state.cvNavData.navData);
  const {
    handleRedirect,
    nodesSelected,
    navigateToChannel,
  } = useMenuRedirect();
  const { isMobile } = useVerifyIsMobile(768);
  const { renderLabel } = useRenderChapas();
  const navigate = useNavigate();

  const getDataNode = data => {
    let res = undefined;

    // nivel uno
    const valueNivel1 = data?.find(
      navNode => navNode?.code === contentInfo.section,
    );

    if (valueNivel1) {
      return valueNivel1;
    }

    data?.find(nodos => {
      const valueNvel2 = nodos?.childs?.find(
        child => child?.code === contentInfo.section,
      );

      if (valueNvel2) {
        res = valueNvel2;
        return true;
      }
    });

    return res;
  };

  const handleCardClick = e => {
    e.stopPropagation();
    pushSelectContentEvent(
      contentInfo,
      nodesSelected,
      carouselTitle,
      contentPosition,
    );

    const nodeToRedirect = getDataNode(main);

    //En caso de ser un nodo de navegación
    if (nodeToRedirect !== undefined && contentInfo?.section !== null) {
      handleRedirect({ node: nodeToRedirect });
      return;
    }

    //En caso de ser un canal redirige a player
    if (
      getContentListV1?.IsLive(contentInfo) &&
      contentInfo?.section === null
    ) {
      return navigateToChannel(
        { ...contentInfo, id: contentInfo?.group_id },
        PUSHTOHISTORY,
      );
    }

    //VCARD
    navigateToChannel(
      `/${getRegion()}/vcard/homeuser/${contentInfo.title_uri}/${
        contentInfo.group_id
      }`,
    );
  };

  return (
    <div className="premium-channel-card" onClick={handleCardClick}>
      {renderLabel(contentInfo)}
      <FadeInImage
        imageAlt={'clarovideo'}
        imageSrc={
          getContentListV1?.getImage(contentInfo, IMG_SIZE?.LARGE) ||
          contentInfo?.image_highlight
        }
        width={isMobile ? 243 : 399}
        height={isMobile ? 136 : 224}
        classNames={['premium-channel-card__image']}
      />
    </div>
  );
};
